/**
 * @generated SignedSource<<a4fd6db66ab7e074016ed7b76916b885>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type BumpSubscriptionVersionResultKind = "BLOCKED" | "OK";
export type bumpVersionButton_BumpSubscriptionVersionMutation$variables = {
  offerId: string;
  toVersion: number;
};
export type bumpVersionButton_BumpSubscriptionVersionMutation$data = {
  readonly Admin: {
    readonly Offer: {
      readonly bumpSubscriptionVersion: {
        readonly kind: BumpSubscriptionVersionResultKind;
        readonly missingElementTypes?: ReadonlyArray<string>;
      };
    };
  };
};
export type bumpVersionButton_BumpSubscriptionVersionMutation = {
  response: bumpVersionButton_BumpSubscriptionVersionMutation$data;
  variables: bumpVersionButton_BumpSubscriptionVersionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "offerId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "toVersion"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "offerId",
    "variableName": "offerId"
  },
  {
    "kind": "Variable",
    "name": "toVersion",
    "variableName": "toVersion"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
},
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "missingElementTypes",
      "storageKey": null
    }
  ],
  "type": "BumpBlocked",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "bumpVersionButton_BumpSubscriptionVersionMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "OfferAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Offer",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": null,
                "kind": "LinkedField",
                "name": "bumpSubscriptionVersion",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "bumpVersionButton_BumpSubscriptionVersionMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "OfferAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Offer",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": null,
                "kind": "LinkedField",
                "name": "bumpSubscriptionVersion",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  },
                  (v2/*: any*/),
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "39475add703041b7fe42460b4e9bfd56",
    "id": null,
    "metadata": {},
    "name": "bumpVersionButton_BumpSubscriptionVersionMutation",
    "operationKind": "mutation",
    "text": "mutation bumpVersionButton_BumpSubscriptionVersionMutation(\n  $offerId: ID!\n  $toVersion: Int!\n) {\n  Admin {\n    Offer {\n      bumpSubscriptionVersion(offerId: $offerId, toVersion: $toVersion) {\n        __typename\n        kind\n        ... on BumpBlocked {\n          missingElementTypes\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "542566d2e78bb1bb4253515bb3826a5c";

export default node;
